export { default as Button } from './Button'
export { default as Captcha } from './Captcha'
export { default as CopyToClipboard } from './CopyToClipboard'
export { default as Error } from './Error'
export { default as LanguageSwitcher } from './LanguageSwitcher'
export { default as Header } from './Header'
export { default as Loading } from './Loading'
export { default as OrderInfo } from './OrderInfo'
export { default as LoginDrawer } from './LoginDrawer'
export { default as OTP } from './OTP'
export { default as PaymentMethodSelector } from './PaymentMethodSelector'
export { default as PaymentMethodSwitcher } from './PaymentMethodSwitcher'
export { default as PaymentMethodsContainer } from './PaymentMethods/Container'
export { default as PaymentMethodsContaineriFrame } from './PaymentMethods/Container/ContaineriFrame'
export { default as PhoneInput } from './PhoneInput'
export { default as Result } from './Result'
export { default as TermsAndPrivacy } from './TermsAndPrivacy'
export { default as WhiteSpace } from './WhiteSpace'
export { default as WingBlank } from './WingBlank'
export { default as PaymentMethodRender } from './PaymentMethodRender'
export { default as MessagePay } from './PaymentMethods/MessagePay'

export { Link } from 'react-router-dom'
